import React, { useState } from "react";
import NeedHelp from "../features/common/NeedHelp";
import FooterOne from "../components/footers/FooterOne";
import ClientImage from "../features/landingpage-one/ClientImage";
import SolutionMade from "../features/landingpage-one/SolutionMade";
import SmartFeature from "../features/common/SmartFeature";
import GetStarted from "../features/common/GetStarted";
import FAQ from "../features/common/FAQ";
import Pricing from "../features/common/Pricing";
import SwiperLandingPageOne from "../features/common/SwiperLandingPageOne";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import '../../node_modules/react-modal-video/scss/modal-video.scss'

const LandingPageOne = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);

  const [dataBlock] = useState({
    subtitle:
      " Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime The standard chunk of those interested.",
    title: "The power of subscription economy.",
    satisfiedGuarantee: "Satisfied Guarantee",
    awosomeSupport: "Awesome Support 24/7",
  });

  return (
      <>
          <section className="pt-[124px] pb-20 bg-cover bg-right-bottom md:bg-center bg-[url('../images/home-2.png')] bg-white">
              <div className="container">
                  <div className="grid grid-cols-1">
                      <div className="max-w-[570px]">
                          <div>
                              <button
                                  onClick={() => setIsOpen(true)}
                                  className="text-custom lightbox"
                              >
                                  <i className="mdi mdi-play shadow-[0px_0px_0px_4px_rgb(230,242,241)] text-[34px] inline-block w-16 leading-[64px] h-16 rounded-full bg-white text-center"></i>
                              </button>
                              <ModalVideo
                                  channel="youtube"
                                  isOpen={isOpen}
                                  videoId="EngW7tLk6R8"
                                  onClose={() => setIsOpen(false)}
                              />
                          </div>
                          <div className="mt-6">
                              <h1 className="md:text-[46px] text-[36px] font-bold capitalize leading-[1.2]">
                                  {dataBlock.title}
                              </h1>
                              <p className="text-muted mt-6">
                                  {dataBlock.subtitle}
                              </p>
                              <div className="mt-4">
                                  <p className="mb-0 text-muted">
                                      <span className="w-2 h-2 inline-block rounded-full mr-2 relative top-[-2px] bg-custom"></span>
                                      {dataBlock.satisfiedGuarantee}
                                  </p>
                                  <p className="mb-0 mt-2 text-muted">
                                      <span className="w-2 h-2 inline-block rounded-full mr-2 relative top-[-2px] bg-custom"></span>
                                      {dataBlock.awosomeSupport}
                                  </p>
                              </div>
                              <div className="mt-8">
                                  <Link to="#" className="btn-custom">
                                      Get Started
                                  </Link>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
          <ClientImage />
          <SolutionMade />
          <SmartFeature />
          <GetStarted />
          <SwiperLandingPageOne />
          <Pricing />
          <FAQ />
          <NeedHelp />
          <FooterOne />
      </>
  );
};

export default LandingPageOne;
